module.exports = __webpack_public_path__ + "static/img/file.f8849981.png";